<template>
  <el-form-item :label="label" :label-width="isZh ? '' : '150px'">
    <!-- 业务编号 -->
    <cargo-multi-line-text-popover
      v-if="isJobNo"
      :show-popover="true"
      :value.sync="item.value"
      style="display: block;width: 230px"
      :visible-arrow="false"
    />
    <!-- 主单号 -->
    <cargo-multi-line-text-popover
      v-else-if="isMbl"
      :show-popover="true"
      :value.sync="item.value"
      style="display: block;width: 230px"
      :visible-arrow="false"
    />
    <!-- 下拉框 -->
    <div v-else-if="item.dataType===1" style="display: flex;width: 230px;">
      <template v-if="displayCurrency">
        <cargo-advance-select
          no="1"
          :select-type="TYPE_NAMES.basic_data_Currency"
          :allow-create="!item.isMore"
          filterable
          filter-type="global"
          :multiple="item.isMore"
          :default-value="defaultValue"
          :default-multiple-value="defaultMultipleValue"
          :show-custom-label-in-option="false"
          :use-tag-name-at-multiple="true"
          :headers="[$t('baseInfo.basicData.currency.code'), $t('baseInfo.basicData.currency.name'), $t('baseInfo.basicData.currency.localName')]"
          :fields="['code', 'name', 'localName']"
          :filter-field-names="['code', 'name', 'localName']"
          style="width: 230px"
          @parentCallBack="onParentCallBack"
        />
      </template>
      <template v-else>
        <cargo-advance-select
          no="1"
          :cache="false"
          :allow-create="!item.isMore"
          filterable
          filter-type="global"
          :multiple="item.isMore"
          :default-value="defaultValue"
          :default-multiple-value="defaultMultipleValue"
          :tag-value="tagName"
          :tag-name="tagName"
          :filter-tag-names="[tagName]"
          :static-options="options"
          style="width: 230px"
          @parentCallBack="onParentCallBack"
        />
        <template v-if="displayByLevel">
          <el-button type="primary" style="margin-left: 3px;width: 30px;min-width: 30px;" @click="showBranchSelectDialog">...</el-button>
          <!-- 分公司选择弹窗 -->
          <branch-select-dialog :visible.sync="branchSelectDialog.visible" :value="branchSelectDialog.value" :office-list="options" @callback="branchSelectDialog.callback" />
        </template>
      </template>
    </div>
    <!-- 日期 -->
    <template v-else-if="item.dataType===5">
      <!-- 范围 -->
      <div v-if="item.isRange" style="display: flex;width: 230px">
        <el-date-picker
          v-model="dateStart"
          no="2"
          type="date"
          value-format="yyyy-MM-dd"
          style="width:110px;margin-right:5px"
          @change="dateRangeChange"
        />&nbsp;-
        <el-date-picker
          v-model="dateEnd"
          no="3"
          type="date"
          value-format="yyyy-MM-dd"
          style="width:110px;margin-left:5px"
          @change="dateRangeChange"
        />
      </div>
      <el-date-picker v-else no="4" :value="innerDate" type="date" value-format="yyyy-MM-dd" style="width: 230px" @input="val=>{item.value=innerDate=val||''}" />
    </template>
    <!-- 是否 -->
    <el-radio-group v-else-if="item.dataType===4" v-model="item.value" no="5" style="width: 230px">
      <el-radio label="true">{{ $t('Message.Yes') }}</el-radio>
      <el-radio label="false">{{ $t('Message.No') }}</el-radio>
      <el-radio label="">{{ $t('CargoMsg.Cargo_All') }}</el-radio>
    </el-radio-group>
    <!-- 文本 -->
    <el-input v-else v-model="item.value" no="6" style="width: 230px" />
  </el-form-item>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import DateUtils from '@/utils/dateUtils'
import * as dw from '@/api/dw'
import BranchSelectDialog from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/BranchSelectDialog'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getCacheListByKey } from '@/utils/basicDataCache'
import lodash from 'lodash'
import cargoMultiLineTextPopover from '@/components/Cargo/Common/cargoMultiLineTextPopover'

export default {
  name: 'ConditionFormItem',
  components: { cargoAdvanceSelect, BranchSelectDialog, cargoMultiLineTextPopover },
  props: {
    item: { type: Object, required: true },
    descriptorRegistry: { type: Object, default: null }
  },
  data() {
    return {
      TYPE_NAMES,
      options: [],
      tagName: '',
      defaultValue: '',
      defaultMultipleValue: [],
      dateStart: '',
      dateEnd: '',
      innerDate: '',
      displayByLevel: false,
      branchSelectDialog: {
        visible: false,
        value: [],
        callback: () => {}
      },
      displayCurrency: false
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    label() {
      if (!this.isZh && this.descriptorRegistry) {
        return this.descriptorRegistry.getDescriptor(this.item.dimensionId).name
      }
      return this.item.displayName
    },
    isJobNo() {
      return ['cargo.fact.job.jobno', 'cargo.fact.job.dmnjobno', 'cargo.fact.charge.jobno', 'cargo.fact.accountactivity.jobno'].includes(this.item.dimensionId)
    },
    isMbl() {
      return ['cargo.fact.job.mbl', 'cargo.fact.job.dmnmbl', 'cargo.fact.charge.mbl', 'cargo.fact.charge.dmnmbl', 'cargo.fact.accountactivity.mbl', 'cargo.fact.accountactivity.mbldimension'].includes(this.item.dimensionId)
    }
  },
  watch: {
    item: {
      immediate: true,
      handler() {
        if (!this.isJobNo && !this.isMbl) {
          if (this.item.dataType === 1) { // string
            this.loadEnumerate()
          } else if (this.item.dataType === 5) { // date
            if (this.item.isRange) {
              const arr = this.item.value.split(',')
              this.dateStart = arr[0]
              this.dateEnd = arr[1] || ''
            } else {
              if (this.item.value) {
                this.innerDate = this.item.value
              } else {
                this.item.value = DateUtils.formatStandardDate(new Date())
                this.innerDate = ''
              }
            }
          }
        }
      }
    }
  },
  methods: {
    async loadEnumerate() {
      this.options = []
      this.tagName = 'name'
      this.displayByLevel = false
      this.displayCurrency = false
      if (['cargo.fact.charge.currency', 'cargo.fact.charge.billCurrency', 'cargo.fact.charge.paymentcurrency', 'cargo.fact.charge.invoicecurrency'].includes(this.item.dimensionId)) {
        this.displayCurrency = true
      }
      if (this.item.factTableId && this.item.dimensionId && !this.displayCurrency) {
        if (this.item.selectAllBranch) {
          const branchZhNames = ['cargo.dimension.department.branchname', 'cargo.dimension.department.parentbranchname', 'cargo.dimension.office.branchname', 'cargo.dimension.office.parentbranchname', 'cargo.dimension.user.branchname']
          const branchEnNames = ['cargo.dimension.department.branchcode', 'cargo.dimension.department.parentbranchcode', 'cargo.dimension.office.branchcode', 'cargo.dimension.office.parentbranchcode', 'cargo.dimension.user.branchcode']
          const branchCodes = ['cargo.dimension.department.branchcode2', 'cargo.dimension.department.parentbranchcode2', 'cargo.dimension.office.branchcode2', 'cargo.dimension.office.parentbranchcode2', 'cargo.dimension.user.branchcode2']
          let field = ''
          if (branchZhNames.includes(this.item.columnId)) {
            field = 'chineseName'
          } else if (branchEnNames.includes(this.item.columnId)) {
            field = 'englishName'
          } else if (branchCodes.includes(this.item.columnId)) {
            field = 'code'
          }
          if (field) {
            const offices = []
            const officeAll = lodash.cloneDeep(getCacheListByKey(TYPE_NAMES.basic_data_Office_All))
            officeAll.sort((a, b) => b.level - a.level)
            const keySet = new Set()
            keySet.add(this.$store.getters.currentOfficeUuid)
            for (const office of officeAll) {
              if (keySet.has(office.uuid)) {
                offices.push(office)
              } else if (office.parentBranchUuid && keySet.has(office.parentBranchUuid)) {
                offices.push(office)
                keySet.add(office.uuid)
              }
            }
            this.options = offices
            this.tagName = field
            this.displayByLevel = this.item.displayByLevel && this.item.isMore
          }
        } else {
          await dw.runtimeServlet({
            operate: 'enumerate',
            factTableId: this.item.factTableId,
            dimensionId: this.item.dimensionId,
            dimensionColumnId: this.item.columnId
          }).then(res => {
            const distinctSet = new Set()
            for (const row of res.content.rows) {
              const name = row.cells[1]
              if (distinctSet.has(name)) {
                continue
              }
              distinctSet.add(name)
            }
            let field = ''
            if (this.item.displayByLevel && this.item.isMore) {
              const branchNames = ['cargo.dimension.department.branchname', 'cargo.dimension.department.parentbranchname', 'cargo.dimension.office.branchname', 'cargo.dimension.office.parentbranchname', 'cargo.dimension.user.branchname']
              const branchCodes = ['cargo.dimension.department.branchcode', 'cargo.dimension.department.parentbranchcode', 'cargo.dimension.office.branchcode', 'cargo.dimension.office.parentbranchcode', 'cargo.dimension.user.branchcode']
              if (branchNames.includes(this.item.columnId)) {
                field = 'chineseName'
              } else if (branchCodes.includes(this.item.columnId)) {
                field = 'code'
              }
            }
            if (field) {
              this.options = this.matchOffices(distinctSet, field)
              this.tagName = field
              this.displayByLevel = true
            } else {
              this.options = Array.from(distinctSet, name => ({ name }))
            }
          })
        }
      }
      if (this.item.isMore) {
        if (this.item.value) {
          this.defaultMultipleValue = this.item.value.split(',')
        } else {
          this.defaultMultipleValue = []
        }
      } else {
        this.defaultValue = this.item.value
      }
    },
    matchOffices(set, field) {
      const offices = []
      const officeAll = lodash.cloneDeep(getCacheListByKey(TYPE_NAMES.basic_data_Office_All))
      officeAll.sort((a, b) => b.level - a.level)
      const parentUuidSet = new Set()
      for (const office of officeAll) {
        if (set.has(office[field]) || parentUuidSet.has(office.uuid)) {
          offices.push(office)
          if (office.parentBranchUuid) {
            parentUuidSet.add(office.parentBranchUuid)
          }
        }
      }
      return offices
    },
    showBranchSelectDialog() {
      const value = []
      for (const option of this.options) {
        if (this.defaultMultipleValue.includes(option[this.tagName])) {
          value.push(option.officeId)
        }
      }
      this.branchSelectDialog.value = value
      this.branchSelectDialog.callback = val => {
        const newValue = []
        for (const option of this.options) {
          if (val.includes(option.officeId)) {
            newValue.push(option[this.tagName])
          }
        }
        this.onParentCallBack({ value: newValue })
      }
      this.branchSelectDialog.visible = true
    },
    onParentCallBack(data) {
      if (this.item.isMore) {
        this.defaultMultipleValue = data.value
        this.item.value = this.defaultMultipleValue.join(',')
        this.item.returnValue = ''
        if (this.item.factTableId && this.item.dimensionId && !this.displayCurrency && this.item.selectAllBranch && this.defaultMultipleValue && this.defaultMultipleValue.length > 0) {
          const offices = []
          const keySet = new Set()
          for (const option of this.options) {
            if (this.defaultMultipleValue.includes(option[this.tagName]) || (option.parentBranchUuid && keySet.has(option.parentBranchUuid))) {
              offices.push(option)
              keySet.add(option.uuid)
            }
          }
          this.item.returnValue = Array.from(offices, p => p[this.tagName]).join(',')
        }
      } else {
        this.defaultValue = data.value
        this.item.value = this.defaultValue
        this.item.returnValue = ''
        if (this.item.factTableId && this.item.dimensionId && !this.displayCurrency && this.item.selectAllBranch && data.uuid) {
          const offices = [data]
          const keySet = new Set()
          keySet.add(data.uuid)
          for (const option of this.options) {
            if (option.parentBranchUuid && keySet.has(option.parentBranchUuid)) {
              offices.push(option)
              keySet.add(option.uuid)
            }
          }
          this.item.returnValue = Array.from(offices, p => p[this.tagName]).join(',')
        }
      }
    },
    dateRangeChange() {
      this.item.value = this.dateStart || ''
      if (this.dateEnd) {
        this.item.value += ',' + this.dateEnd || ''
      }
    }
  }
}
</script>
